import { Form, FormSet } from '../../../reducers/store';

export const RecommendationLabels = [
  'Care Gap Outreach Recommendation',
  'Diabetes Recommendation',
  'Helix Recommendation',
];

export const isRecommendationForm = (form: Form) => !!form.isRecommendationForm;

export const hasRecommendationForm = (formSets: FormSet[]) => {
  return formSets.some((formSet) =>
    Object.values(formSet.forms).some((form) => isRecommendationForm(form)),
  );
};
